<div class="ws-page">
  <header class="page-head">
    <div>
      <p class="kicker">Overview · Enforcement</p>
      <div class="page-head-title-row">
        <h2>Dashboard</h2>
        <app-page-refresh-btn [loading]="loading()" (refresh)="reload()" />
      </div>
      <p class="muted ws-lead">
        Operational summary for sanctioned plans, LiDAR scans, measurements and compliance review.
      </p>
    </div>
  </header>

  <p class="error" *ngIf="error()">{{ error() }}</p>

  <section class="summary-strip" aria-label="Operational summary">
    <a
      *ngFor="let card of summaryCards()"
      class="summary-card"
      [attr.data-key]="card.key"
      [routerLink]="card.route"
    >
      <p class="summary-label">{{ card.label }}</p>
      <p class="summary-value">{{ card.value }}</p>
      <p class="summary-sub">{{ card.sub }}</p>
      <span class="summary-link">Open section →</span>
    </a>
  </section>

  <div class="ws-dashboard-grid">
    <section class="page-card building-checks-panel">
      <h3 class="panel-title">Active building checks</h3>
      <p class="muted ws-lead">
        Recent plots in the enforcement pipeline — expand a row for plan, scan and measurement detail.
      </p>

      <p class="ws-loading" *ngIf="loading()">Loading building checks…</p>

      <p class="ws-empty" *ngIf="!loading() && !activeBuildingChecks().length">
        No building checks recorded. Upload a sanctioned plan or register a LiDAR scan to begin.
      </p>

      <div class="table-wrap" *ngIf="!loading() && activeBuildingChecks().length">
        <table class="data checks-table">
          <thead>
            <tr>
              <th>Plot</th>
              <th>Progress</th>
              <th>Compliance</th>
              <th class="col-action">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of activeBuildingChecks()">
              <td class="col-plot"><strong>{{ plotLabel(row.plotRef) }}</strong></td>
              <td class="col-progress">{{ row.progressLabel }}</td>
              <td class="col-compliance">
                <div class="cell-stack">
                  <span class="compliance-tag rule-tag" [attr.data-status]="row.ruleCheckStatus">
                    {{ row.ruleCheckLabel }}
                  </span>
                  <span
                    class="violation-note"
                    *ngIf="row.violationLabel"
                    [attr.data-status]="row.violationStatus"
                  >
                    {{ row.violationLabel }}
                  </span>
                </div>
              </td>
              <td class="col-action">
                <div class="action-group">
                  <button type="button" class="btn-action" (click)="openDetails(row)">Details</button>
                  <button
                    type="button"
                    class="btn-action"
                    *ngIf="canReviewFlag(row)"
                    (click)="openFlag(row)"
                  >
                    Review flag
                  </button>
                  <button
                    type="button"
                    class="btn-action btn-action-muted"
                    *ngIf="row.flagId && !canReviewFlag(row)"
                    (click)="openFlag(row)"
                  >
                    View case
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <aside class="ws-aside">
      <section class="page-card">
        <h3 class="panel-title">Compliance summary</h3>
        <ul class="compliance-list">
          <li *ngFor="let item of complianceSummary()">
            <span>{{ item.label }}</span>
            <strong>
              {{ item.value }}<span class="muted" *ngIf="item.total"> / {{ item.total }}</span>
            </strong>
          </li>
        </ul>
      </section>

      <section class="page-card">
        <div class="panel-head-inline">
          <h3 class="panel-title">Quick actions</h3>
          <button type="button" class="link-btn" (click)="quickActionsOpen.set(!quickActionsOpen())">
            {{ quickActionsOpen() ? 'Hide' : 'Show' }}
          </button>
        </div>
        <ul class="quick-actions" *ngIf="quickActionsOpen()">
          <li *ngFor="let action of quickActions()">
            <a [routerLink]="action.route">
              <strong>{{ action.label }}</strong>
              <span>{{ action.detail }}</span>
            </a>
          </li>
        </ul>
      </section>
    </aside>
  </div>
</div>
